import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { MoveListService } from "@scaffold/services/move-list.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { AddDataComponent } from "@scaffold/dialogs/add-data/add-data.component";
import { ViewUpdateService } from "@scaffold/services/view-update.service";
import { CourseService } from "@scaffold/services/course.service";
import { HTMLModalComponent } from "@scaffold/dialogs/htmlmodal/htmlmodal.component";
import {
  NbMenuItem,
  NbMenuService,
  NbDialogService,
  NbDialogRef,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { ExportModalComponent } from "@scaffold/dialogs/export-modal/export-modal.component";
import { ItemsService } from "@scaffold/services/items.service";
import { TranslationService } from "@services/translation.service";

@Component({
  selector: "scaffold-menu",
  templateUrl: "./scaffold-menu.component.html",
  styleUrls: [
    "../../rendered.component.scss",
    "./scaffold-menu.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaffoldMenuComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy {
  public destroy$: Subject<boolean> = new Subject<boolean>();
  created: boolean = false;
  unique = Math.random() * 9000000;
  buttons: NbMenuItem[] = [];
  moveButton;
  cancelMove: NbMenuItem = {
    title: "Cancel Move",
    icon: {
      pack: "far",
      icon: "times-circle",
    },
    hidden: true,
    data: {
      operation: "cancelListMove",
      use_icon: true,
    },
  };
  dialogRef: NbDialogRef<AddDataComponent>;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public moveList: MoveListService,
    private itemsService: ItemsService,
    public dialog: NbDialogService,
    private viewUpdate: ViewUpdateService,
    private courseService: CourseService,
    private nbMenuService: NbMenuService,
    private translationService:TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
    this.moveList
      .moveUpdatesListener()
      .pipe(takeUntil(this.destroy$))
      .subscribe((i) => {
        console.log(i);
        if (i) {
          this.cancelMove.hidden = false;
          if (this.moveButton) {
            this.moveButton.hidden = true;
          }
        } else {
          this.cancelMove.hidden = true;
          if (this.moveButton) {
            this.moveButton.hidden = false;
          }
        }
        this.update();
      });

    this.item.content.forEach((b) => {
      let content 
      if(b.translation_key){
         content = this.translationService.getTranslatedContent(b.translation_key)
         content=!b.text_transform?content:this.translationService.transform(content,b.translation_key)
      }
      let button: NbMenuItem = {
        title:content|| b.text,
        data: {
          operation: b.operation,
          item: b,
          use_icon: b.use_icon,
          color: b.color,
          use_referenced: b.use_referenced
        },
      };
      if (b.icon) {
        let icon = b.icon.split(/\s/);
        if (icon.length > 1) {
          button.icon = {
            pack: icon[0],
            icon: icon[1].replace(/fa-/, ""),
          };
        }
      }
      this.buttons.push(button);
      if (b.operation === "openMove") {
        this.moveButton = button;
        this.buttons.push(this.cancelMove);
      }
    });

    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(
          ({ tag }) => tag === "scaffold-menu-" + this.info.id + this.unique
        )
      )
      .subscribe((menu) => {
        console.log(menu);
        this.execute(menu.item.data.item);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  execute(e) {
    console.log(e);
    this[e.operation](e);
  }

  openSettings(e) {
    console.log(this.info);
    console.log(e);
    let item = this.info;
    if (e.use_referenced && this.info.reference_id) {
      item = {
        type: this.info.reference_type,
        id: this.info.reference_id,
      };
    }
    this.renderedService.openView("create", item);
  }

  openRead(e) {
    console.log(this.info);
    console.log(e);
    let item = this.info;
    if (e.use_referenced && this.info.reference_id) {
      item = {
        type: this.info.reference_type,
        id: this.info.reference_id,
      };
    }
    this.renderedService.openView("read", item);
  }

  preview(e) {
    this.courseService
      .get(
        `${this.info.type}/${this.info.id}?mode=${this.info.view_details.mode}&format=html`
      )
      .subscribe((v) => {
        let settings: any = {
          context: {
            data: {
              content: v.html,
              title:
                this.info.title +
                "_" +
                (this.info.view_details.title || this.info.view_details.mode),
            },
          },
        };
        this.dialog.open(HTMLModalComponent, settings);
      });
  }

  export(e) {
    let settings: any = {
      context: {
        data: {
          title:
            this.info.title +' '+  this.translationService.getTranslatedContent("gradebook_data","Gradebook Data"),
          size: 'half'
        },
      },
    };
    this.dialog.open(ExportModalComponent, settings);

  }

  openMove(e) {
    console.log(this.info);
    this.moveList.requestMove(this.info);
    // this.moveHandler.emit('move');
    // this.itemsService.routeUpdated('move');
  }
  cancelListMove(e) {
    this.moveList.requestMove(null);
  }

  duplicateItem(e) {
    console.log(this.info);

    var item = this.info;
    this.moveList.requestMove(item, true);
    /*this.createData(item.type, item.parent, true, item)*/
  }
  createData(type, parent, add, duplicate) {
    console.log(this.item);
    if (this.item.use_defaults) {
      if (!this.created) {
        this.created = true;
        var default_data = {
          type: type,
          data: {},
        };
        if (this.item.new_defaults) {
          this.item.new_defaults.forEach((def) => {
            default_data.data[def.key] = def.value;
          });
        }
        let path = "";
        if (this.info.type && this.info.id)
          path += this.info.type + "/" + this.info.id + "/";
        path += type;
        this.itemsService.createData(path, default_data).subscribe((d) => {
          this.created = false;
          if (this.info) {
            this.viewUpdate.triggerListChange({
              list_type: "list",
              type: d.type,
              added: d.id,
              parent_type: this.info.type,
              parent_id: this.info.id,
            });
          }
        });
      }
    } else {
      console.log(parent);
      var data = {};
      if (this.item.param && this.item.req_value) {
        data[this.item.param] = this.item.req_value;
      }
      let settings: any = {
        context: {
          data: {
            comp: this,
            parent: parent,
            type: type,
            allowAdd: add,
            duplicate: duplicate,
            data: data,
          },
        },
      };
      this.dialogRef = this.dialog.open(AddDataComponent, settings);
      this.dialogRef.onClose.subscribe((result) => {
        //console.log(result)
        if (result && (result !== "string" || result.length > 0)) {
        }
      });
    }
  }

  deleteData() {
    console.log("Delete", this.info);
    this.renderedService.deleteData(this.info);
  }
}
